<template>
  <div id="checkout_confirm">
    <call />
    <pop-alert />
    <!-- header -->
    <header>
      <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()"></header-app>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <!-- menu detail -->
      <section>
        <div
          class="l-main l-main--bg-border l-main--no-pd-bot l-main--bg-border--green pt-60"
        >
          <div class="l-main__head">
            <a
              href="#"
              class="l-main__head--control l-main__head--control--back"
            >
              <img src="/assets/images/icon/icon-back-white.svg?v=2" alt="" />
            </a>
            <div class="l-main__head--title">お支払い</div>
            <a href="#" class="l-main__head--control"> </a>
          </div>
          <div class="l-check-cart">
            <div class="l-check-cart__body l-check-cart__body--grey">
              <div class="l-check-cart__incomplete">
                <h1>※まだ注文は完了しておりません。</h1>
                <p>
                  内容をご確認の上、「注文を確定する」<br />ボタンを押してください。
                </p>
              </div>
              <div class="c-box-method c-box-method--grey">
                <div class="c-box-method__title mb-24">
                  <img
                    src="/assets/images/icon/icon-card.svg"
                    alt=""
                  />選択されたクレジットカード
                </div>
                <div class="l-check-cart__title-sub mb-18" v-if="user.creditCardType == 2">イオンカード</div>
                <div class="l-check-cart__title-sub mb-18" v-if="user.creditCardType == 1">イオンカード以外（VISA、MASTERのみ）</div>
                <ul class="mb-28 no-border">
                  <li class="">
                    <label class="c-checkbox">
                      <input type="checkbox" name="checkbox" id="checkbox-1" v-model="registerAeonRegi" />
                      <span class="c-checkbox__checkmark"></span>
                    </label>
                    <label
                      for="checkbox-1"
                      class="c-box-method__name c-box-method__name--sm"
                    >
                      <b>このクレジットカード情報をイオンタウンアプリに登録する。</b
                      ><br />
                      ※登録しない場合は、都度ご入力ください。
                    </label>
                  </li>
                </ul>
              </div>
            </div>
            <div class="l-check-cart__foot">
              <div class="text-center mb-16">
                ご注文状況はアプリで通知させて頂きます。
              </div>
              <div class="mb-16">
                <router-link class="checkout-terms" :to="`/about/termsofuse?from-page=${$route.fullPath}`">ご利用規約を確認</router-link>
                <label class="c-checkbox c-checkbox--label">
                  <input type="checkbox" name="checkbox" id="checkbox-2" v-model="agree" />
                  <span class="c-checkbox__checkmark"></span>
                  イオンタウンアプリの利用規約に同意する
                </label>
              </div>
              <div class="c-btn c-btn--red box-center" @click.prevent="placeOrder">注文を確定する</div>
            </div>
          </div>
        </div>
      </section>
      <div class="layer" :class="{ fade: !loading }"></div>
      <div class="screen-loader loader--style1" :class="{ fade: !loading }" title="0">
        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
          <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
          <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"></path>
        </svg>
      </div>
       <alert :message="alert_msg" 
      :show="alert_show" 
      :closeModal="closeModal" 
      :confirm_show="confirm_show" 
      :confirm_message="confirm_msg" 
      :confirm_callback="confirm_callback" 
      :confirm_hide_cancel="confirm_hide_cancel"
      :label_cancel="confirm_label_cancel"
      :label_ok="confirm_label_ok"
      ></alert>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import Menu from "../components/Menu.vue";
import Alert from "../components/Alert.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { DB } from "../config/const";
import firebase from "@firebase/app";
import { getUser, getUserAeonRegi, getProviderByShopCategory } from "../store/firestore";
import PopAlert from "../components/PopAlert.vue";

export default Vue.extend({
  name: "MobileOrderOption",
  components: {
    'header-app': Header,
    'menu-app': Menu,
    'alert': Alert,
    PopAlert
  },
  mixins: [Tenant],
  async created(){
    const userId = this.$store.state.userId;
    const shopId = this.$store.getters.shopId;
    if(userId){
      this.user = await getUser(userId);
      this.userAeonRegi = await getUserAeonRegi(userId, shopId);
    }
    const result = await getProviderByShopCategory(0)
    this.tenants = result;
  },
  data(){
    const cartData = this.$store.state.cart;
    return {
      cartData: Object.values(cartData),
      user: undefined,
      tenants: [],
      agree: false,
      registerAeonRegi: true,
      loading: false,
      isOrdering: false
    }
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    async placeOrder() {
      if(!this.isUserOrderable()){
        this.alert("モバイルオーダーのご利用にはログイン・本人確認が必要です。");
        return;
      }
      if(this.isOrdering) return;
      this.isOrdering = true;
      if (!this.agree) {
        this.alert("ご利用規約に同意されていません。");
        this.isOrdering = false;
        return;
      }
      this.loadingShow();
      const userId = this.$store.state.userId;
      const userRef = DB.collection('user').doc(userId);
      const shopId = this.$store.state.shopId;
      const userAeonRegiRef = DB.collection(`/shop/${shopId}/shopUserAeonRegi`).doc(userId);
      const userData = await userRef.get();
      const cardType = userData.data().creditCardType;
      if (this.registerAeonRegi) {
        userRef?.update({
          aeonRegiId: this.userAeonRegi.aeonRegiId
        });
        userAeonRegiRef?.set({
          userId: userId,
          saved: true,
          creditCardType: cardType
        },{merge:true})
      } else {
        userRef?.update({
          aeonRegiId: firebase.firestore.FieldValue.delete(),
          creditCardType: firebase.firestore.FieldValue.delete(),
        })
      }
      const idToken = await this.getIdToken();
      if (!idToken) return;
      const cartData = this.$store.state.cart;
      const couponCode = Object.values(this.$store.state.cart).find(item => item.couponCode?.length > 0)?.couponCode;
      this.$store.dispatch('updateCart', { cartData: cartData, couponCode: couponCode })
      .catch(async e => {
        this.loadingHide();
        this.isOrdering = false;
        console.error(e);
        await this.confirm("注文確定処理時にエラーが発生しました。" + (e?.message||""), true);
        this.$router.push('/mobileorder/cart?from-page=checkout');
      })
      .then(() => {
        this.$store.dispatch('placeOrder', userData.data().creditCardType).then((orderGroupId) => {
          this.loadingHide();
          this.isOrdering = false;
          this.$router.push('/mobileorder/complete/'+orderGroupId);
        })
        .catch(async e => {
          this.loadingHide();
          this.isOrdering = false;
          console.error(e);
          await this.confirm("注文確定処理時にエラーが発生しました。" + (e?.message||""), true);
          this.$router.push('/mobileorder/cart?from-page=checkout');
        })
      })
    }
  }
});
</script>